import { ShoppingBag } from 'lucide-react';
import { selectCartItemCount, useCartStore } from '../../store/cartStore';

interface CartButtonProps {
  onClick: () => void;
}

/** Floating cart button — visible only when the cart has items. */
export function CartButton({ onClick }: CartButtonProps) {
  const count = useCartStore(selectCartItemCount);
  if (count === 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className="fixed bottom-6 right-4 sm:right-6 z-30 bg-wca-red hover:bg-wca-red-dark text-white rounded-full pl-5 pr-6 h-14 shadow-xl flex items-center gap-3 transition-colors"
      aria-label={`Open cart (${String(count)} item${count === 1 ? '' : 's'})`}
    >
      <ShoppingBag size={20} />
      <span className="font-mono font-semibold tabular-nums">{count}</span>
    </button>
  );
}
